package ir.alirezaivaz.finglish.ui.theme

import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF625690)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFE7DEFF)
val onPrimaryContainerLight = Color(0xFF4A3E76)
val secondaryLight = Color(0xFF515B92)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFDEE0FF)
val onSecondaryContainerLight = Color(0xFF3A4379)
val tertiaryLight = Color(0xFF7D5262)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFFFD9E4)
val onTertiaryContainerLight = Color(0xFF623B4A)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFFDF7FF)
val onBackgroundLight = Color(0xFF1C1B20)
val surfaceLight = Color(0xFFFDF7FF)
val onSurfaceLight = Color(0xFF1C1B20)
val surfaceVariantLight = Color(0xFFE6E0EC)
val onSurfaceVariantLight = Color(0xFF48454E)
val outlineLight = Color(0xFF79757F)
val outlineVariantLight = Color(0xFFCAC4CF)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF312F35)
val inverseOnSurfaceLight = Color(0xFFF4EFF7)
val inversePrimaryLight = Color(0xFFCCBDFF)
val surfaceDimLight = Color(0xFFDDD8E0)
val surfaceBrightLight = Color(0xFFFDF7FF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF7F2FA)
val surfaceContainerLight = Color(0xFFF1ECF4)
val surfaceContainerHighLight = Color(0xFFECE6EE)
val surfaceContainerHighestLight = Color(0xFFE6E1E9)

val primaryDark = Color(0xFFCCBDFF)
val onPrimaryDark = Color(0xFF34275E)
val primaryContainerDark = Color(0xFF4A3E76)
val onPrimaryContainerDark = Color(0xFFE7DEFF)
val secondaryDark = Color(0xFFBAC3FF)
val onSecondaryDark = Color(0xFF222C61)
val secondaryContainerDark = Color(0xFF3A4379)
val onSecondaryContainerDark = Color(0xFFDEE0FF)
val tertiaryDark = Color(0xFFEEB8CA)
val onTertiaryDark = Color(0xFF492534)
val tertiaryContainerDark = Color(0xFF623B4A)
val onTertiaryContainerDark = Color(0xFFFFD9E4)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF141318)
val onBackgroundDark = Color(0xFFE6E1E9)
val surfaceDark = Color(0xFF141318)
val onSurfaceDark = Color(0xFFE6E1E9)
val surfaceVariantDark = Color(0xFF48454E)
val onSurfaceVariantDark = Color(0xFFCAC4CF)
val outlineDark = Color(0xFF938F99)
val outlineVariantDark = Color(0xFF48454E)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE6E1E9)
val inverseOnSurfaceDark = Color(0xFF312F35)
val inversePrimaryDark = Color(0xFF625690)
val surfaceDimDark = Color(0xFF141318)
val surfaceBrightDark = Color(0xFF3A383E)
val surfaceContainerLowestDark = Color(0xFF0F0D13)
val surfaceContainerLowDark = Color(0xFF1C1B20)
val surfaceContainerDark = Color(0xFF201F24)
val surfaceContainerHighDark = Color(0xFF2B292F)
val surfaceContainerHighestDark = Color(0xFF36343A)

val lightScheme = lightColorScheme(
    primary = primaryLight,
    onPrimary = onPrimaryLight,
    primaryContainer = primaryContainerLight,
    onPrimaryContainer = onPrimaryContainerLight,
    secondary = secondaryLight,
    onSecondary = onSecondaryLight,
    secondaryContainer = secondaryContainerLight,
    onSecondaryContainer = onSecondaryContainerLight,
    tertiary = tertiaryLight,
    onTertiary = onTertiaryLight,
    tertiaryContainer = tertiaryContainerLight,
    onTertiaryContainer = onTertiaryContainerLight,
    error = errorLight,
    onError = onErrorLight,
    errorContainer = errorContainerLight,
    onErrorContainer = onErrorContainerLight,
    background = backgroundLight,
    onBackground = onBackgroundLight,
    surface = surfaceLight,
    onSurface = onSurfaceLight,
    surfaceVariant = surfaceVariantLight,
    onSurfaceVariant = onSurfaceVariantLight,
    outline = outlineLight,
    outlineVariant = outlineVariantLight,
    scrim = scrimLight,
    inverseSurface = inverseSurfaceLight,
    inverseOnSurface = inverseOnSurfaceLight,
    inversePrimary = inversePrimaryLight,
    surfaceDim = surfaceDimLight,
    surfaceBright = surfaceBrightLight,
    surfaceContainerLowest = surfaceContainerLowestLight,
    surfaceContainerLow = surfaceContainerLowLight,
    surfaceContainer = surfaceContainerLight,
    surfaceContainerHigh = surfaceContainerHighLight,
    surfaceContainerHighest = surfaceContainerHighestLight,
)

val darkScheme = darkColorScheme(
    primary = primaryDark,
    onPrimary = onPrimaryDark,
    primaryContainer = primaryContainerDark,
    onPrimaryContainer = onPrimaryContainerDark,
    secondary = secondaryDark,
    onSecondary = onSecondaryDark,
    secondaryContainer = secondaryContainerDark,
    onSecondaryContainer = onSecondaryContainerDark,
    tertiary = tertiaryDark,
    onTertiary = onTertiaryDark,
    tertiaryContainer = tertiaryContainerDark,
    onTertiaryContainer = onTertiaryContainerDark,
    error = errorDark,
    onError = onErrorDark,
    errorContainer = errorContainerDark,
    onErrorContainer = onErrorContainerDark,
    background = backgroundDark,
    onBackground = onBackgroundDark,
    surface = surfaceDark,
    onSurface = onSurfaceDark,
    surfaceVariant = surfaceVariantDark,
    onSurfaceVariant = onSurfaceVariantDark,
    outline = outlineDark,
    outlineVariant = outlineVariantDark,
    scrim = scrimDark,
    inverseSurface = inverseSurfaceDark,
    inverseOnSurface = inverseOnSurfaceDark,
    inversePrimary = inversePrimaryDark,
    surfaceDim = surfaceDimDark,
    surfaceBright = surfaceBrightDark,
    surfaceContainerLowest = surfaceContainerLowestDark,
    surfaceContainerLow = surfaceContainerLowDark,
    surfaceContainer = surfaceContainerDark,
    surfaceContainerHigh = surfaceContainerHighDark,
    surfaceContainerHighest = surfaceContainerHighestDark,
)
